import { createApi } from '@reduxjs/toolkit/query/react';

import { createApiBaseQuery, Methods } from '@app/api/shared';
import {
  SocialIntegrationEmailParsingRuleEndpoints as Endpoints,
  type SocialIntegrationEmailParsingRuleListRequest,
  type SocialIntegrationEmailParsingRuleListResponseData,
  type SocialIntegrationEmailParsingRuleUpdateRequest,
  type SocialIntegrationEmailParsingRuleUpdateResponse,
} from '@app/api/SocialIntegrationEmailParsingRule/types';
import { SOCIAL_INTEGRATION_EMAIL_PARSING_RULE } from '@app/constants';

export const socialIntegrationEmailParsingRuleApi = createApi({
  reducerPath: 'socialIntegrationEmailParsingRuleApi',
  baseQuery: createApiBaseQuery(SOCIAL_INTEGRATION_EMAIL_PARSING_RULE),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.SocialIntegrationEmailParsingRuleUpdate]: mutation<
      SocialIntegrationEmailParsingRuleUpdateResponse,
      SocialIntegrationEmailParsingRuleUpdateRequest
    >({
      query: ({ data, ...params }) => ({
        url: 'Update',
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.SocialIntegrationEmailParsingRuleList]: query<
      SocialIntegrationEmailParsingRuleListResponseData,
      SocialIntegrationEmailParsingRuleListRequest
    >({
      query: ({ socialIntegrationId, ...params }) => ({
        url: `List/${socialIntegrationId}`,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useSocialIntegrationEmailParsingRuleUpdateMutation,
  useSocialIntegrationEmailParsingRuleListQuery,
  useLazySocialIntegrationEmailParsingRuleListQuery,
} = socialIntegrationEmailParsingRuleApi;
